import type { OrderHistoryParams } from './orderContracts'

// Order query keys factory.
// Mutations invalidate via the factory only — never raw arrays.

export type OrderHistoryQueryKey = Omit<OrderHistoryParams, 'page' | 'limit'>

export const orderKeys = {
  all: ['order'] as const,
  details: () => [...orderKeys.all, 'detail'] as const,
  detail: (id: string) => [...orderKeys.details(), id] as const,
  histories: () => [...orderKeys.all, 'history'] as const,
  history: (params: OrderHistoryQueryKey) => [...orderKeys.histories(), params] as const,
  filters: () => [...orderKeys.all, 'filters'] as const,
  calculateFees: (offeringId: string, tokenQuantity: number) =>
    [...orderKeys.all, 'calculate-fees', offeringId, tokenQuantity] as const,
}
